import React from "react";
import { Button } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";

import styles from "./client-auto-complete-dropdown.css";

const { ["container"]: containerClassName, ["header"]: headerClassName } = styles as any;

type ClientAutoCompleteDropdownProps = {
  onClickAddNew: React.MouseEventHandler<HTMLElement>;
  canCreateClient?: boolean;
};

export const ClientAutoCompleteDropdown: React.FC<ClientAutoCompleteDropdownProps> = ({
  onClickAddNew,
  canCreateClient = true,
  children,
}) => {
  return (
    <div className={containerClassName}>
      {canCreateClient && (
        <div>
          <div className={headerClassName}>
            <Button
              icon={<PlusCircleOutlined />}
              onClick={onClickAddNew}
              style={{ marginLeft: "10px" }}
            >
              Add New
            </Button>
          </div>
        </div>
      )}
      <div>{children}</div>
    </div>
  );
};
